// Shared by string rendering, placeholder mounting and select options. These keys describe
// rune type chips; some deliberately have no PNG on the icons CDN.
// Singular spell is a chip; the plural spells list keeps its PNG. General ability is the
// HUD category chip (bronze hexagon + G), with no PNG, like trap ability.
export const ABILITY_BADGE_CANON: Record<string, number> = {
    full_ability: 1, ability: 1, attack_ability: 1, quick_ability: 1, free_ability: 1,
    reaction_ability: 1, opportunity_attack_ability: 1, passive_ability: 1,
    curse: 1, menta: 1, sanguine: 1, spell: 1, lair_ability: 1, trap_ability: 1,
    general_ability: 1,
};

export const ABILITY_BADGE_ALIASES: Record<string, string> = {
    full_abilities: 'full_ability', abilities: 'ability', attack_abilities: 'attack_ability',
    quick_abilities: 'quick_ability', free_abilities: 'free_ability', reaction_abilities: 'reaction_ability',
    opportunity_attack_abilities: 'opportunity_attack_ability', passive_abilities: 'passive_ability',
    curses: 'curse', mentas: 'menta', sanguines: 'sanguine', trap_abilities: 'trap_ability',
};

export function abilityTypeForKey(key: unknown): string {
    if (typeof key !== 'string') return '';
    if (Object.prototype.hasOwnProperty.call(ABILITY_BADGE_CANON, key)) return key;
    return Object.prototype.hasOwnProperty.call(ABILITY_BADGE_ALIASES, key) ? ABILITY_BADGE_ALIASES[key]! : '';
}
